import { IState } from '../store';
import { IMapTabs } from '../store/map_tabs';

export const selectMapTabs = (state: IState): IMapTabs => {
  return state.mapTabs;
};
